export enum XeoAddOnPlanEnum {
  XEO_RVT = 'xeoRVT', // trial only, see getRvtTrialExpiresAt
}
